import { withTheme } from '../config';
import { Skeleton } from '@rneui/base/dist/Skeleton';
export { Skeleton };
export default withTheme(Skeleton, 'Skeleton');
